import NotificationAlert from "react-notification-alert";
import MaterialReactTable from "material-react-table";
import { t } from 'react-multi-lang';
import { MRT_Localization_FR } from "material-react-table/locales/fr";
import { MRT_Localization_EN } from "material-react-table/locales/en";
import { Button, Card, Container, Row, Col } from "react-bootstrap";
import React, { useEffect, useCallback, useState } from "react";
import { fetchSimulationC, simulationCDeleted } from "../../Redux/simulationCReduce";
import { useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import SweetAlert from "react-bootstrap-sweetalert";

// core components
function SimulationC({ client }) {
  document.title = "Liste des Simulations commerciale";
  const dispatch = useDispatch();
  const navigate = useHistory();
  const [alert, setAlert] = React.useState(null);
  let lang = window.localStorage.getItem("lang");
  const notificationAlertRef = React.useRef(null);
  const [entities, setEntities] = React.useState([]);
  const [loader, setLoader] = React.useState(true);
  const notify = (place, msg, type) => {
    var options = {};
    options = {
      place: place,
      message: (
        <div>
          <div>
            {msg}
          </div>
        </div>
      ),
      type: type,
      icon: "nc-icon nc-bell-55",
      autoDismiss: 7,
    };
    notificationAlertRef.current.notificationAlert(options);
  };

  function ajouter() {
    navigate.push(client + '/ajouterSimulationC');
  }


  const [columns] = useState([
    {
      header: "Type",
      accessorKey: "type"
    },
    {
      header: "Date 1",
      accessorKey: "date1"
    },
    {
      header: "Date 2",
      accessorKey: "date2"
    },
    {
      header: "Date d'envoie",
      accessorKey: "updatedAt",
      Cell: ({ cell }) => {
        const { etat } = cell.row.original;
        if (etat !== 1) return null; // n’affiche rien si etat ≠ 1

        const value = cell.getValue();
        if (!value) return "-";

        const date = new Date(value);
        return date.toLocaleString("fr-FR", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        });
      },
    },
    {
      accessorKey: 'id',
      header: 'Détails',
      Cell: ({ cell, row }) => (
        <div className="actions-right block_action">
          {console.log(client + "/simulation/detail/" + cell.row.original.id)}
          <Button
            className=" mr-1 float-left"
            type="button"
            variant="info"
            onClick={() => {
              navigate.push(client + "/simulation/detail/" + cell.row.original.id);
            }}
          >
            <i className="fas fa-eye"></i>
          </Button>
        </div>
      ),
    },
    {
      accessorKey: 'id',
      header: 'Actions',
      Cell: ({ cell, row }) => (
        cell.row.original.etat == 0 &&
        <div className="actions-right block_action">
          <Button
            className=" mr-1 float-left"
            type="button"
            variant="warning"
            onClick={() => {
              navigate.push(client + "/simulationC/update/" + cell.row.original.id);
            }}
          >
            <i className="fas fa-pencil"></i>
          </Button>
          <Button
            id={"idLigne_" + cell.row.original.id}
            onClick={(e) => {
              verif(cell.row.original.id)
            }}
            variant="danger"
            className="btn-danger btn"
          >
            <i className="fa fa-trash" id={"idLigne_" + cell.row.original.id} />
          </Button>
        </div>
      ),
    },
  ])

  const hideAlert = () => {
    setAlert(null);
  };

  const confirmMessage = (id, e, test) => {
    setAlert(
      test === 1 ? (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="Êtes-vous sûr de continuer la suppression ? "
          onConfirm={() => deletesimulationC(id, e)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Oui"
          cancelBtnText="Non"
          showCancel
        />
      ) : (
        <SweetAlert
          style={{ display: "block", marginTop: "-100px" }}
          title="Êtes-vous sûr de continuer la suppression ? "
          onConfirm={() => deletesimulationC(id, e)}
          onCancel={() => hideAlert()}
          confirmBtnBsStyle="info"
          cancelBtnBsStyle="danger"
          confirmBtnText="Oui"
          cancelBtnText="Non"
          showCancel
        />
      )
    );
  };


  function verif(id, e) {

    confirmMessage(id, e, 1)

  }


  function deletesimulationC(id, e) {
    dispatch(simulationCDeleted({ id })).then((val) => {
      notify("tr", "Simulation supprimé avec succées", "success")
      getSimulation()
      hideAlert();
    });
  }

  function ListTable({ list, loader }) {
    return (
      <MaterialReactTable
        state={{ isLoading: loader }}
        columns={columns}
        data={list}
        enableColumnActions={true}
        enableColumnFilters={true}
        enablePagination={true}
        enableSorting={true}
        enableBottomToolbar={true}
        enableTopToolbar={true}
        muiTableBodyRowProps={{ hover: false }}
        displayColumnDefOptions={{
          'mrt-row-numbers': {
            size: 10,
          },
          'mrt-row-expand': {
            size: 10,
          },
        }}
        enableColumnFilterModes
        initialState={{
          columnVisibility: { description: false },
          density: 'compact',
          showGlobalFilter: true,
        }}
        muiSearchTextFieldProps={{
          placeholder: t("search"),
          sx: { minWidth: '18rem' },
          variant: 'outlined',
        }}

        filterFns={{
          myCustomFilterFn: (row, id, filterValue) => {
            const value = row.getValue(id);
            return typeof value === 'string' && value.toLowerCase().includes(filterValue.toLowerCase());
          },
        }}
        globalFilterFn="myCustomFilterFn"

        localization={
          lang === "fr"
            ? MRT_Localization_FR
            : MRT_Localization_EN
        }
      />
    );
  }

  const getSimulation = useCallback(async () => {
    var marche = await dispatch(fetchSimulationC({ client }));
    setEntities(marche.payload);
    setLoader(false)
  }, [dispatch]);
  useEffect(() => {
    getSimulation()
  }, [getSimulation]) //now shut up eslint
  return (
    <>
      <Container fluid>
        {alert}
        <div className="rna-container">
          <NotificationAlert ref={notificationAlertRef} />
        </div>
        <Row>
          <Col md="12">
            <Button
              id="saveBL"
              className="btn-wd btn-outline mr-1 float-left"
              type="button"
              variant="info"
              onClick={ajouter}
            >
              <span className="btn-label">
                <i className="fas fa-plus"></i>
              </span>
              Ajouter simulation
            </Button>
          </Col>
          <Col md="12">

            <Card>
              <Card.Header>
                <Card.Title as="h4">Liste des simulations</Card.Title>
              </Card.Header>
              <Card.Body className="table-style">
                <ListTable list={entities} loader={loader} ></ListTable>
              </Card.Body>
            </Card>
          </Col>

        </Row>
      </Container>
    </>
  );
}

export default SimulationC;
